/**
 * Check if user has permission
 * @param {Array<string>} permissions - The permissions required.
 * @param {Array<string>} [userPermissions] - The permissions of the connected user.
 * @returns {boolean} - The result of the comparison.
 */
const hasPermission = (permissions, userPermissions = []) => (
  userPermissions?.length
    ? permissions.every((permission) => userPermissions.includes(permission))
    : true
);

export default hasPermission;
